import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import type { FilterEditorStore } from 'widgets/FilterEditor/store/FilterEditorStore'
import { FilterEditorProvider } from 'widgets/FilterEditor/context/filterEditorContext'
import { FilterGroups } from './index'

type IFilterEditorProps = {
  store: FilterEditorStore
  parentsDropdownId?: string[]
}

export const FilterEditor: FC<IFilterEditorProps> = observer(({ store, parentsDropdownId }) => (
  <FilterEditorProvider store={store}>
    <FilterGroups parentsDropdownId={parentsDropdownId} />
  </FilterEditorProvider>
))
